import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {tap} from "rxjs/operators";
import {StateStorageService} from "./state-storage.service";

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private appConfig: any;

    constructor(private http: HttpClient) {
        this.http = http;
    }

    loadAppConfig(url: string): Promise<void> {
        return this.http.get(url)
            .pipe(
                tap((config: any) => {
                    this.appConfig = config;
                }))
            .toPromise();
    }

    getAppConfig(path: string, def: any = null): any {
        if (this.appConfig) {
            const segments = path.split('.')
            let value = this.appConfig;
            for (let seg of segments) {
                if (value[seg]) value = value[seg];
                else return def;
            }
            return value;
        }
        return def;
    }
}
